import position from "./position";

export default { position }